import * as transliteration from 'transliteration';
// eslint-disable-next-line import/prefer-default-export
export const convertUnicodeToAscii = (inputText) => transliteration.transliterate(inputText);

export function convertToPascalCase(text) {
  const withoutDiacritics = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  const words = withoutDiacritics.split(' ');
  const pascalCaseText = words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join('');

  return pascalCaseText;
}

export const convertDataToUrl = async (blobOrFile) => {
  const reader = new FileReader();
  reader.readAsDataURL(blobOrFile);

  await new Promise(
    // eslint-disable-next-line no-return-assign
    (resolve) =>
      // eslint-disable-next-line no-promise-executor-return
      (reader.onload = () => {
        resolve();
      })
  );

  return reader.result;
};
